import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

export type StatusTone = keyof typeof adminTokens.statusTone;

// Backend status values (docs/api/orders-api.md, docs/api/cases-api.md) and
// the two labels a screen passes for something never sent, by the tone the
// design's Status badges rule gives them (BADGE-R3…R8). Values are matched as
// received, so a differently cased value is not a known value.
const toneByStatus: Record<string, StatusTone> = {
  new: "processing",
  in_progress: "processing",
  created: "processing",
  assigned: "processing",
  processing: "processing",
  out_for_delivery: "moving",
  completed: "done",
  waiting: "needsAttention",
  support: "needsAttention",
  "Not yet sent": "needsAttention",
  "Not sent": "needsAttention",
  error: "error",
  cancelled: "inactive",
};

const unknownStatusTone: StatusTone = "inactive";

export const knownStatuses = Object.keys(toneByStatus);

export const toneForStatus = (status: string): StatusTone =>
  Object.prototype.hasOwnProperty.call(toneByStatus, status)
    ? toneByStatus[status]
    : unknownStatusTone;
